<template>
    <div id="GeNumber">
      <span v-for="gefahrnummer in this.gefahrnummern" :key="gefahrnummer.gefahrnummer">
        <GeNumberObj :gefahrnummer="gefahrnummer"/>
      </span>
    </div>
    <Footer backLink="/" />
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import GeNumberObj from "@/components/Gefahrgut/GeNumberObj.vue";
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: "GeNumber",
  components: {
    Header,
    Footer,
    GeNumberObj,
  },
  props: {
    
  },
  data() {
    return {
      gefahrnummern: [],
    };
  },
  methods: {

    async getGefahrnummern() {
      try {
        const response = await axios.get(
          'https://feuerwehr-server.org:5000/gefahrnummern'
        );
        console.log(response.data);

        response.data.sort((a,b) => a.gefahrnummer - b.gefahrnummer);

        return response.data;
      } catch (err) {
        console.log(err);
        return false;
      }
    },
  },
  async created(){
    //console.log(this.benutzer.data);
    this.gefahrnummern = await this.getGefahrnummern();
  },
  setup() {
  }
};
</script>

<style lang="scss">
#GeNumber{
    //max-height: 500px;
    height: 90vh;
    overflow-y: auto;
}

@media screen and (max-height: 768px) {
  #GeNumber{
    padding-bottom: 10.3vh;
  }
}
</style>